import { Pipeline, PipelineEnvironment, PipelineRepository } from '@telespot/domain';

export interface ListPipelinesInput {
  lang: string;
  searchTerm?: string;
  limit?: number;
  lastItemCreatedAt?: Date;
  environmentFilter?: PipelineEnvironment;
}

export interface ListPipelinesOutput {
  id: string;
  name: { [lang: string]: string };
  env: PipelineEnvironment;
  createdAt: Date;
}

export interface IListPipelinesQuery {
  /**
   * Lists pipelines ordered by `createdAt` descending (newest first),
   * paginated by the `lastItemCreatedAt` cursor and narrowed by the optional
   * search term and environment filter. `lang` is retained for compatibility
   * but no longer drives the sort order. Repository errors propagate so the
   * caller's pagination effect can surface them.
   */
  execute(input: ListPipelinesInput): Promise<ListPipelinesOutput[]>;
}

export class ListPipelinesQuery implements IListPipelinesQuery {
  constructor(private readonly pipelineRepository: PipelineRepository) {}

  public async execute(input: ListPipelinesInput): Promise<ListPipelinesOutput[]> {
    const pipelines = await this.pipelineRepository.getAll(
      input.lang,
      input.searchTerm,
      input.limit,
      input.lastItemCreatedAt,
      input.environmentFilter
    );
    return pipelines.map((pipeline: Pipeline) => ({
      id: pipeline.id,
      name: pipeline.name,
      env: pipeline.env,
      createdAt: pipeline.createdAt ?? new Date(),
    }));
  }
}
